import { GOOGLE_FIT } from "../appsdevices/constants";
import { Platform, PLATFORMS } from "../core";

export const showWarningsOfStopSupportGoogleFit = device => {
    const isIos = Platform.OS === PLATFORMS.ios;
    const isGoogleFitConnected = device.vendor === GOOGLE_FIT && device.connected && device.googleHealthConnectMigrationEnabled;

    return !isIos && isGoogleFitConnected;
};